import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Wakbbu from "../pages/wakbbu/page";
import King from "../pages/king/page";
import Mallang from "../pages/mallang/page";

const routes: RouteObject[] = [
  // 그냥볼 is off the menu for now: the site opens on 왁뿌볼, and 그냥볼 is still reachable at /basic
  {
    path: "/",
    element: <Navigate to="/wakbbu" replace />,
  },
  {
    path: "/basic",
    element: <Home />,
  },
  {
    path: "/wakbbu",
    element: <Wakbbu />,
  },
  {
    path: "/king",
    element: <King />,
  },
  {
    path: "/mallang",
    element: <Mallang />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
